export default {
    id: '1',
    name: '张三'
}


// WEBPACK FOOTER //
// ./src/configure/http/mock/response/system/account/info.js